import { MutationTree } from 'vuex';

import userManager from '@/auth';
import {
  LIST_MASTER_ACCOUNTS,
  SET_MASTER_ACCOUNT,
  SET_CURRENT_USER_DATA,
  SET_ERROR,
  UPDATE_USER_LOCALE,
  UserState
} from './types';

const mutations: MutationTree<UserState> = {
  [LIST_MASTER_ACCOUNTS](state: UserState, payload) {
    state.masterAccounts = payload;
    if (!sessionStorage.getItem('selectedMasterAccount')) {
      sessionStorage.setItem('selectedMasterAccount', JSON.stringify(state.masterAccounts[0]));
    }
    state.selectedMasterAccount = JSON.parse(sessionStorage.getItem('selectedMasterAccount')!);
  },
  [SET_MASTER_ACCOUNT](state: UserState, payload) {
    sessionStorage.setItem('selectedMasterAccount', JSON.stringify(payload));
    state.selectedMasterAccount = payload;
  },
  [SET_ERROR](state: UserState, payload) {
    state.errorMessage = payload;
  },
  [SET_CURRENT_USER_DATA](state: UserState, payload) {
    if (payload !== undefined) {
      state.currentUser = {
        name: payload['cognito:username'],
        email: payload.email,
        roles: payload['cognito:groups'] ? payload['cognito:groups'] : [],
        locale: 'en'
      };
      if (payload.locale && payload.locale.startsWith('fr')) {
        state.currentUser.locale = 'fr';
      }

      state.isLogged = true;
    }
  },

  [UPDATE_USER_LOCALE](state: UserState, payload: { locale: string }) {
    if (payload !== undefined) {
      if (state.currentUser) {
        if (payload.locale.startsWith('fr')) {
          state.currentUser.locale = 'fr';
        }

        if (payload.locale.startsWith('en')) {
          state.currentUser.locale = 'en';
        }

        userManager.setUserLocale(payload.locale);
      }
    }
  }
};

export default mutations;
